// extracted by mini-css-extract-plugin
export default {"text":"TextComponent_text__MkhIg"};